import axios from 'axios';

import * as config from '../../config';

export default {
  state: {
    activity: [],
  },
  actions: {
    async getActivity({ state, commit }, page) {
      try {
        let response = await axios.get(`${config.API_URL}/activity`);

        commit('setActivity', response);

        return response;
      } catch (e) {}
    },
  },
  mutations: {
    setActivity(state, { data }) {
      state.activity = data;
    },
  },
};